export class OTA_Error {
    public code: number;
    public shortText: string;
}